import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonpopComponent } from './commonpop.component';
import { DefaultComponent } from "../../theme/pages/default/default.component";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    component: DefaultComponent,
    children: [
      {
        path: "",
        component: CommonpopComponent,
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [CommonpopComponent],
  declarations: [CommonpopComponent],
})
export class CommonpopModule { }
